import type { FontSize, FontProperties, FontDefinition } from './types';

export const parseFontDefinition = ({
  variants,
  default: defaultVariant,
}: FontDefinition): Record<FontSize, FontProperties> =>
  Object.entries(variants).reduce(
    (acc, [key, variant]) => ({
      ...acc,
      [key as FontSize]: {
        ...defaultVariant,
        ...variant,
      },
    }),
    {} as Record<FontSize, FontProperties>,
  );
